import React, {useEffect, useMemo, useRef} from 'react'
import clsx from 'clsx'
import {Select} from './Select'
import {useTranslation} from 'react-i18next'

export const PopAdvOpt = ({
  toggle,
  targetEl,
  options = [],
  advance_option_key = {start_date: '', end_date: '', is_stamp: true},
  onClose = () => {},
  onChange = (e, v) => {},
}) => {
  const {t} = useTranslation()

  const ref = useRef()

  useEffect(() => {
    const el = targetEl?.current || targetEl
    if (!toggle || !el?.getBoundingClientRect) {
      ref.current.style.display = `none`
      return
    }

    const prect = el.offsetParent.getBoundingClientRect() || {}
    const rect = el.getBoundingClientRect()

    const y = rect.y - prect.y

    ref.current.style.top = `${y + rect.height + 4}px`
    ref.current.style.left = `${el.offsetLeft + rect.width}px`
    ref.current.style.display = `flex`

    const fn = event => {
      if (
        !event.target.matches(
          '.ds-menu--basic.ds-unique-pop-adv-opt, .ds-menu--basic.ds-unique-pop-adv-opt *'
        )
      ) {
        onClose()
      }
    }

    const d = document
    d.addEventListener('click', fn)

    return () => {
      d.removeEventListener('click', fn)
    }
  }, [toggle, targetEl, onClose])

  const handleChange = (ev, data, key) => {
    const _default = {start_date: '', end_date: '', is_stamp: true}
    const _advance_option_key = {..._default, ...data}
    if (!_advance_option_key.is_stamp && options.length > 0) {
      if (_advance_option_key.start_date === '') _advance_option_key.start_date = options[0].id
      if (_advance_option_key.end_date === '') _advance_option_key.end_date = options[0].id
    }
    onChange(ev, _advance_option_key)
  }

  return (
    <div
      ref={ref}
      className={clsx('ds-menu--basic ds-pl-16 ds-pr-12 ds-unique-pop-adv-opt')}
      style={{
        display: 'none',
        width: 312,
        height: 182,
        transform: 'translateX(-100%)',
        position: 'fixed',
      }}
    >
      <i
        className="ds-icon-close ds-icon-20x20"
        style={{top: 8, right: 16, position: 'absolute'}}
        onClick={onClose}
      />
      <div className="ds-menu--basic-wrapper">
        <div className="ds-t060r ds-tg700">{t('calendar.view.add.adv-option.title')}</div>
        <div className="ds-flex-row ds-ml-40">
          <div className="ds-menu-item" style={{gap: 16}}>
            <input
              type="radio"
              checked={advance_option_key.is_stamp}
              className="ds-radio"
              onClick={e =>
                handleChange(e, {
                  ...advance_option_key,
                  is_stamp: true,
                  start_date: '',
                  end_date: '',
                })
              }
            ></input>
            {t('calendar.view.add.adv-option.opt-stamp')}
          </div>
          <div className="ds-menu-item" style={{gap: 16}}>
            <input
              type="radio"
              checked={!advance_option_key.is_stamp}
              className="ds-radio"
              onClick={e => handleChange(e, {...advance_option_key, is_stamp: false})}
            ></input>
            {t('calendar.view.add.adv-option.opt-range')}
          </div>
        </div>
        <div
          className={clsx('ds-flex-col', {'ds-disabled': advance_option_key.is_stamp})}
          style={{gap: 8}}
        >
          <Select
            value={advance_option_key?.start_date}
            label={t('calendar.view.add.adv-option.sel-start-date')}
            onChange={handleChange}
            items={options}
            render={(item, index, click) => {
              return (
                <div
                  key={index}
                  className="ds-menu-item"
                  onClick={e => click(e, {...advance_option_key, start_date: item.id}, index)}
                >
                  <span className="ds-text-ellipsis">{item.name}</span>
                </div>
              )
            }}
            selectedDisplay={(value, items) => items.find(f => f.id === value)?.name}
          />
          <Select
            value={advance_option_key?.end_date}
            label={t('calendar.view.add.adv-option.sel-end-date')}
            onChange={handleChange}
            items={options}
            render={(item, index, click) => {
              return (
                <div
                  key={index}
                  className="ds-menu-item"
                  onClick={e => click(e, {...advance_option_key, end_date: item.id}, index)}
                >
                  <span className="ds-text-ellipsis">{item.name}</span>
                </div>
              )
            }}
            selectedDisplay={(value, items) => items.find(f => f.id === value)?.name}
          />
        </div>
      </div>
    </div>
  )
}
